import React from 'react';
import * as RadixToast from '@radix-ui/react-toast';

type ToastProps = {
    isToastOpen: boolean;
    onOpenChange: (newState:boolean) => void;
    title: string;
    message: string;
};

const Toast = ({ isToastOpen, onOpenChange, title, message }: ToastProps) => {
    return (
        <RadixToast.Provider>
            <RadixToast.Root
                className="grid grid-cols-[auto_max-content] items-center gap-x-[15px] rounded-md bg-white p-[15px] shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] [grid-template-areas:_'title_action'_'description_action'] data-[swipe=cancel]:translate-x-0 data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[state=closed]:animate-hide data-[state=open]:animate-slideIn data-[swipe=end]:animate-swipeOut data-[swipe=cancel]:transition-[transform_200ms_ease-out]"
                open={isToastOpen}
                onOpenChange={onOpenChange}
                duration={3000} >
                <RadixToast.Title className="mb-[5px] text-[15px] font-medium text-slate12 [grid-area:_title]">{title}</RadixToast.Title>
                <RadixToast.Description className="m-0 text-[13px] leading-[1.3] text-slate11 [grid-area:_description]">{message}</RadixToast.Description>
            </RadixToast.Root>
            <RadixToast.Viewport className="z-50 fixed top-[10%] left-[50%] translate-x-[-50%]" />
        </RadixToast.Provider>
    )
}

export default Toast;


